import React from 'react';
import { observer } from 'mobx-react';
import { ConceptCategoryStore } from '@seedlang/stores';
import InPlaceText from 'components/form/in_place_text';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import autobind from 'autobind-decorator';
import ConceptCategoryConceptIndex from 'pages/builder/concepts/concept_category_concept_index';
import Stack from 'components/layout/stack';
import Grid from 'components/layout/grid';

@observer
class ConceptCategoryEdit extends React.Component {

  componentDidMount() {
    this.loadData();
  }

  componentWillUnmount() {
    ConceptCategoryStore.clearShowData();
  }

  @autobind loadData() {
    ConceptCategoryStore.getShow({ ids: {conceptCategoryId: this.props.params.conceptCategoryId }}, this.afterGetShow);
  }

  @autobind afterGetShow() {
    ConceptCategoryStore.reloadShow();
  }

  render() {
    return (
      <Stack gap='sm' alignItems='stretch'>
        <Grid columns={2}>
          <InPlaceText
            legend='Name'
            defaultValue={ConceptCategoryStore.showDataField('name')}
            model='concept_categories'
            field='name'
            id={ConceptCategoryStore.showDataField('id')}
          />
          <InPlaceText
            legend='Slug'
            defaultValue={ConceptCategoryStore.showDataField('slug')}
            model='concept_categories'
            field='slug'
            id={ConceptCategoryStore.showDataField('id')}
          />
        </Grid>
        <Grid columns={4}>
          <InPlaceCheckbox
            legend='Published'
            model='concept_categories'
            field='published'
            value={ConceptCategoryStore.showDataField('published')}
            id={ConceptCategoryStore.showDataField('id')}
          />
          <InPlaceCheckbox
            legend='Featured'
            model='concept_categories'
            field='featured'
            value={ConceptCategoryStore.showDataField('featured')}
            id={ConceptCategoryStore.showDataField('id')}
          />
          <InPlaceCheckbox
            legend='Content'
            model='concept_categories'
            field='content'
            value={ConceptCategoryStore.showDataField('content')}
            id={ConceptCategoryStore.showDataField('id')}
          />
          <InPlaceCheckbox
            legend='Collaborative'
            model='concept_categories'
            field='collaborative'
            value={ConceptCategoryStore.showDataField('collaborative')}
            id={ConceptCategoryStore.showDataField('id')}
          />
        </Grid>
        <InPlaceText
          legend='Description'
          richText
          inputType='textarea'
          model='concept_categories'
          field='description'
          defaultValue={ConceptCategoryStore.showDataField('description')}
          id={ConceptCategoryStore.showDataField('id')}
        />
        <fieldset>
          <legend>Concepts</legend>
          <ConceptCategoryConceptIndex
            conceptCategoryId={this.props.params.conceptCategoryId}
            hideFilter
          />
        </fieldset>
      </Stack>
    );
  }
}

export default ConceptCategoryEdit;
